// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2Mz8e","inputWrap":"CustomTip_inputWrap__1TVSV"};